import React from "react";

import { IgButton, IgSwitch, IgTypography } from "@intelligems/ig-theme";
import { ConfigurationDto } from "@intelligems/ig-types";
import { FormControlLabel, Grid } from "@mui/material";

import { useGetCogsData } from "../../../api/cogs/get-cogs-data";
import { usePatchConfigurations } from "../../../api/configurations/patch-configurations";
import { useConfiguration } from "../../../api/configurations/use-configuration";
import { useGetOrgId } from "../../../api/organizations/get-organization";
import { useLoggedInUser } from "../../../api/user-auths/login";

export const AutomaticManagement = () => {
  const user = useLoggedInUser();
  const autoSyncCogs = useConfiguration("auto_sync_cogs");
  const mutateConfigurations = usePatchConfigurations();
  const fetchCogs = useGetCogsData();
  const orgId = useGetOrgId();

  const onSyncCogsClick = () => {
    if (user.isSuccess) {
      fetchCogs.mutate(
        {
          sync: true,
          email: user.data.user.email,
        },
        {
          onSuccess: () => {
            setTimeout(
              () => window.scrollTo({ top: 0, behavior: "smooth" }),
              1000
            );
          },
        }
      );
    }
  };

  return (
    <Grid container item direction={"column"} rowSpacing={2}>
      <Grid item>
        <IgTypography variant="h6" sx={{ fontSize: "18px" }}>
          Automatic Management
        </IgTypography>
      </Grid>
      <Grid item>
        <IgButton
          variant={"contained"}
          loading={fetchCogs.isPending}
          onClick={onSyncCogsClick}
        >
          Update COGS from Shopify*
        </IgButton>
      </Grid>
      <Grid item sx={{ marginLeft: "6px" }}>
        <FormControlLabel
          control={
            <IgSwitch
              checked={autoSyncCogs?.value}
              disabled={mutateConfigurations.isPending}
              onClick={() => {
                const data: ConfigurationDto[] = [
                  {
                    key: "auto_sync_cogs",
                    type: "Boolean",
                    topic: "GENERAL",
                    value: !autoSyncCogs?.value,
                    organizationId: orgId,
                  },
                ];
                mutateConfigurations.mutate(data);
              }}
            />
          }
          label={"Update COGS from Shopify Daily*"}
        />
      </Grid>
      <Grid item sx={{ marginTop: "-15px" }}>
        <IgTypography igStyle={"thin"}>
          *This will overwrite any manually-set COGS values as well as product
          groups.
        </IgTypography>
      </Grid>
    </Grid>
  );
};
